import { render, staticRenderFns } from "./ConsultValidationRem.vue?vue&type=template&id=caf08736&scoped=true"
import script from "./ConsultValidationRem.vue?vue&type=script&lang=js"
export * from "./ConsultValidationRem.vue?vue&type=script&lang=js"
import style0 from "./ConsultValidationRem.vue?vue&type=style&index=0&id=caf08736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf08736",
  null
  
)

export default component.exports